import { Token, USDT, USDC, ETH } from '@/config/constants';

interface TokenSelectorItemProps {
  isSelected: boolean;
  token: Token;
  onSelect: (token: Token) => void;
}

const TokenSelectorItem = (props: TokenSelectorItemProps) => {
  const { token, onSelect, isSelected } = props;

  const onClick = () => {
    onSelect(token);
  };

  return (
    <button
      key={token.symbol}
      onClick={onClick}
      className={`flex items-center justify-center space-x-2 px-4 py-2 rounded-lg transition-colors duration-200 flex-1 ${
        isSelected
          ? 'bg-blue-500 text-white border border-blue-500'
          : 'bg-slate-100 text-slate-700 border border-slate-200 hover:bg-slate-200'
      }`}
    >
      <img src={token.logo} alt={token.symbol} className="w-5 h-5 rounded-full" />
      <span className="font-medium">{token.symbol}</span>
    </button>
  );
};

interface TokenSelectorProps {
  selectedToken: Token;
  onSelect: (token: Token) => void;
}

const TokenSelector = (props: TokenSelectorProps) => {
  const { selectedToken, onSelect } = props;

  return (
    <div className="flex space-x-2 w-full">
      {[USDT, USDC, ETH].map((token) => (
        <TokenSelectorItem
          key={token.symbol}
          isSelected={selectedToken.symbol === token.symbol}
          token={token}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
};

export default TokenSelector;
